import SectionFirstPage from '@/components/common/SectionFirstPage';
import SectionBlockChain from '@/components/pages/InnovativeTechnologySolutions/SectionBlockChain';
import SectionIoTService from '@/components/pages/InnovativeTechnologySolutions/SectionIoTService';
import React from 'react';
import { useTranslation } from 'react-i18next';

const InnovativeTechnologySolutions = () => {
  const { t } = useTranslation();
  return (
    <div>
      <SectionFirstPage
        title={
          <h1>
            {t('Innovative')}
            <br />
            {t('Technology')}
            <br />
            <span>{t('Solution')}</span>
          </h1>
        }
        desc={t(
          'Pioneering the Future with Cutting-Edge Technologies — from Blockchain and AI to IoT and Whitelabel Solutions, Warppipe empowers businesses with the most advanced innovations on the market.'
        )}
      />
      <SectionBlockChain />
      <SectionIoTService />
    </div>
  );
};

export default React.memo(InnovativeTechnologySolutions);
